import React, { FC, useEffect, useState, useCallback } from "react";
import SiemensLogo from "assets/Brand Logo/Siemens-logo.svg?url";
import Notification, { NotificationType } from "./Notification";
import { signalRService } from "services/signalRService";
import { useIsAuthenticated } from "@azure/msal-react";
import Profile from "./profile";
import { useSelector } from "react-redux";
import { RootState } from "redux/store/store";
import t from "utils/i18n";
import { useLogout } from "hooks/useLogout";
interface Props {}

const Header: FC<Props> = () => {
  const [notificationData, setNotificationData] = useState<NotificationType[]>(
    [],
  );
  const isAuthenticated = useIsAuthenticated();
  const userClaims = useSelector((state: RootState) => state.auth.claims);

  const { logout } = useLogout();

  const handleLogout = useCallback(async () => {
    await logout();
  }, [logout]);

  const handleNotificationReceived = useCallback((notification: any) => {
    setNotificationData((prev) => [notification, ...prev]); // Append new notifications
    // Handle notification logic here
  }, []);

  useEffect(() => {
    signalRService.on("NotificationReceived", handleNotificationReceived);

    return () => {
      signalRService.off("NotificationReceived");
    };
  }, [handleNotificationReceived]);

  return (
    <div className="fixed flex items-center justify-between px-4 top-0 z-40 h-[44px] w-screen bg-elevation-1">
      <div className="flex flex-row items-center justify-center space-x-4">
        <img src={SiemensLogo} alt={t("header.logoAlt")} />
        <span>{t("header.separator")}</span>
        <h2>{t("header.appName")}</h2>
      </div>
      <div className="flex items-center pr-5 gap-5 h-11">
        {isAuthenticated && (
          <div className="flex items-center h-full">
            <Notification notifications={notificationData} />
          </div>
        )}
        <div className="flex items-center h-full mb-1">
          {isAuthenticated && (
            <Profile
              lastname={userClaims?.family_name}
              username={userClaims?.given_name}
              email={
                userClaims?.email ||
                userClaims?.preferred_username ||
                t("common.na")
              }
              onLogout={handleLogout}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
